<template>
  <component
    :is="partnerLink ? 'a' : 'router-link'"
    v-bind="linkProps"
    :class="linkClass"
  >
    <img
      :src="imageSrc"
      :alt="imageAlt"
      decoding="async"
      loading="lazy"
      :class="imageClass"
    />
  </component>
</template>

<script>
export default {
  name: 'PartnerImageLink',
  props: {
    partnerLink: { type: Boolean, default: false },
    link: { type: String, required: true },
    imageSrc: { type: String, required: true },
    imageAlt: { type: String, required: false },
    linkClass: { type: String, required: false },
    imageClass: { type: String, required: false },
  },
  computed: {
    linkProps() {
      return this.partnerLink
        ? { href: this.link, target: '_blank', rel: 'noopener' }
        : { to: 'timing-scoring' };
    },
  },
};
</script>
